import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { AllSecondaryDeploymentReport } from "../../../Apis/TransferStationReport/secondaryDeploymentTransactionReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { GetZone, GetVehicleType } from "../../../Apis/organizationApi";
import { getTransferStationTypes } from "../../../Apis/transferStationApi";
import Select from "react-select";
import Loader from "../../../Common/Loader/loader";
import CommonApiStore from "../MainStore/commonApiStore";
import { exportToPDF } from "../../../../utils/exportToPDF";
import SmallLoader from "../../../../Hooks/SmallLoader";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL } from "../../../Services/baseApiUrl";
const AnimalCarReport = ({ t }) => {
  const location = useLocation();
  const { fetchAllCommonReportsApi, commonReportsData, loading } =
    CommonApiStore();
  const isClearingAndDisinfectionReport =
    location.pathname === "/clearing-disinfection-bin-capsule-report";
  const reportTitle = isClearingAndDisinfectionReport
    ? "PCTS/FCTS/Capsule Clearing & Disinfection report"
    : "Vehicle Washing Report";
  const safeReportTitle = reportTitle.replace(/[\\/:*?"<>|]/g, "_");
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };
  const headers = [
    "zone",
    "Ward",
    //"date",    
    "vehicleNumber",
    "vehicleType",
    "driverName",
    "driverNumber",
    "pickupDateTime",
    ...(isClearingAndDisinfectionReport
      ? ["transferStationName", "transferStationTypeName", "Functional/Non-Functional"]
      : []),
    "latitude",
    "longitude",
    "beforeImage",
    "afterImage",
  ];

  const transformedData = commonReportsData.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
    //date: formatDateForDisplay(item.createdDate) || "N/A",
    driverName: item.driverName || "N/A",
    driverNumber: item.mobileNumber || "N/A",
    zone: item.zoneName || "N/A",
    Ward: item.wardname || "N/A",
    vehicleType: item.vehicleType || item.VehicleType || item.vehicle_type || "N/A",  // ✅ Added
    pickupDateTime: formatDateForDisplay(item.beforeDateTime) || "N/A",
    transferStationName:
      item.transferStationName || item.TransferStationName || "N/A",
    transferStationTypeName:
      item.transferStationTypeName || item.TransferStationTypeName || "N/A",
    "Functional/Non-Functional": item.remarks || item.Remarks || "N/A",
    latitude: item.beforeLatitude || "N/A",
    longitude: item.beforeLongitude || "N/A",
    beforeImage: item.beforeImageUrl || "N/A",
    afterImage: item.afterImageUrl || "N/A",
    // afterImage: item.afterImageURL || "N/A",
  }));
  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allZones, setAllZones] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const [isExcelWithImagesLoading, setIsExcelWithImagesLoading] = useState(false);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
  const [transferStationTypes, setTransferStationTypes] = useState([]);
  const [transferStationTypeId, setTransferStationTypeId] = useState("");
  const isProd = isGHMC();

  const fetchAllVehicleTypeData = async () => {
    try {
      const vehicleTypesData = await GetVehicleType();
      setVehicleTypeDetails(vehicleTypesData);
    } catch (error) {
      console.error("Error fetching vehicle types:", error);
    }
  };

  const getSelectedVehicleTypeIds = () => selectedVehicleTypes.map(v => v.value);

  const downloadClearingReportExcelWithImages = async () => {
    const vehicleTypeIds = getSelectedVehicleTypeIds();
    const params = {
      CollectionPointTypeId: 11,
      FromDate: startDate,
      ToDate: endDate,
      ZoneId: zoneId || undefined,
      VehicleNumber: vehicleNumber.trim() || undefined,
      vehcileNumber: vehicleNumber.trim() || undefined,
      withImages: true,
      TransferStationTypeId: transferStationTypeId || undefined,
    };

    if (vehicleTypeIds.length > 0) {
      params.vehicleTypeIds = vehicleTypeIds.join(",");
    }

    const response = await axiosInstance.get(
      `${API_BASE_URL}api/SecondaryCollection/ClearingandDisinfectionofBinCollectionTransportationReportExcel`,
      {
        params,
        paramsSerializer: (paramsObj) => {
          const searchParams = new URLSearchParams();
          Object.entries(paramsObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "") return;
            searchParams.append(key, value);
          });
          return searchParams.toString();
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${safeReportTitle}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const fetchTransferStationTypeData = async () => {
    try {
      const typesData = await getTransferStationTypes();
      setTransferStationTypes(Array.isArray(typesData) ? typesData : []);
    } catch (error) {
      console.error("Error fetching transfer station types:", error);
    }
  };

  const fetchAllZoneData = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const getClearingReportEndpoint = () =>
    isClearingAndDisinfectionReport
      ? "ClearingandDisinfectionofBinCollectionTransportationReport"
      : undefined;

  useEffect(() => {
    fetchAllZoneData();
    fetchAllVehicleTypeData();
    if (isClearingAndDisinfectionReport) {
      fetchTransferStationTypeData();
    }
    fetchAllCommonReportsApi(
      "11",
      startDate,
      endDate,
      zoneId,
      vehicleNumber,
      getSelectedVehicleTypeIds(),
      transferStationTypeId,
      getClearingReportEndpoint()
    );
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchAllCommonReportsApi(
      "11",
      startDate,
      endDate,
      zoneId,
      vehicleNumber,
      getSelectedVehicleTypeIds(),
      transferStationTypeId,
      getClearingReportEndpoint()
    );
  };

  // Function to format dates for display

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `${reportTitle} ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      safeReportTitle,
    );
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(2, 2, 3, 8);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Ward",
      // "Date",
      ...(isClearingAndDisinfectionReport ? ["Ward Name"] : []),
      "Vehicle Number",
      "Vehicle Type",
      "Driver Name",
      "Driver Number",
      "Pickup Date Time",
      ...(isClearingAndDisinfectionReport
        ? ["Transfer Station Name", "Transfer Station Type Name", "Functional/Non-Functional"]
        : []),
      "Latitude",
      "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 15) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });
    transformedData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName ?? "N/A",
          item.wardname ?? "N/A",
          // formatDateForDisplay(item.createdDate) || "N/A",
          item.vehicleNumber ?? "N/A",
          item.vehicleType ?? "N/A",
          item.driverName ?? "N/A",
          item.driverNumber ?? "N/A",
          formatDateForDisplay(item.beforeDateTime) ?? "N/A",
          ...(isClearingAndDisinfectionReport
            ? [
              item.transferStationName ?? "N/A",
              item.transferStationTypeName ?? "N/A",
              item.remarks ?? "N/A",
            ]
            : []),
          item.beforeLatitude ?? "N/A",
          item.beforeLongitude ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 15) {
            cell.alignment = {
              horizontal: "left",
              vertical: "middle",
              wrapText: true,
            };
          } else {
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${safeReportTitle}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const dowanloadExcel = async (withImages = false) => {
    if (withImages) {
      setIsExcelWithImagesLoading(true);
    } else {
      setIsExcelLoading(true);
    }
    try {
      if (isClearingAndDisinfectionReport && withImages) {
        await downloadClearingReportExcelWithImages();
        return;
      }

      const vehicleTypeIds = getSelectedVehicleTypeIds();

      console.log("Selected Vehicle Type IDs:", vehicleTypeIds); // ✅ Debug

      const response = await axiosInstance.get(
        `${API_BASE_URL}api/SecondaryCollection/UnifiedWasteCollectionTransportationReportDownloadExcelSheet`,
        {
          params: {
            CollectionPointTypeId: 11,
            // FromDate: new Date(startDate).toISOString(),
            // ToDate: new Date(endDate).toISOString(),
            FromDate: startDate,
            ToDate: endDate,
            ZoneId: zoneId || undefined,
            VehicleNumber: vehicleNumber.trim() || undefined,
            vehicleTypeIds: vehicleTypeIds.length > 0 ? vehicleTypeIds.join(',') : undefined,
            TransferStationTypeId: transferStationTypeId || undefined,
            withImages: withImages,
          },
          // ✅ This is the key fix — forces repeated keys like vehicleTypeIds=1&vehicleTypeIds=2
          paramsSerializer: (params) => {
            const searchParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value === undefined || value === null) return;
              if (Array.isArray(value)) {
                value.forEach((v) => searchParams.append(key, v));
              } else {
                searchParams.append(key, value);
              }
            });
            return searchParams.toString();
          },
          headers: { Authorization: `Bearer ${getToken()}` },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${safeReportTitle}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelLoading(false);
      setIsExcelWithImagesLoading(false);
    }
  };

  const downloadPdf = async () => {
    await exportToPDF({
      fileName: safeReportTitle.replace(/\s+/g, "_"),
      title: reportTitle,
      generatedOnText: `Report on: ${generationTime}, ${getCurrentDateTime1()}`,
      data: transformedData,
      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Zone",
          accessor: (row) => row.zoneName ?? "N/A",
          width: 25,
        },
        ...(isClearingAndDisinfectionReport
          ? [
            {
              header: "Ward Name",
              accessor: (row) => row.wardName ?? row.WardName ?? "N/A",
              width: 25,
            },
          ]
          : []),
        {
          header: "Ward",
          accessor: (row) => row.wardName ?? "N/A",
          width: 25,
        },
        {
          header: "Date",
          accessor: (row) => formatDateForDisplay(row.createdDate) || "N/A",
          width: 25,
        },
        {
          header: "Vehicle Number",
          accessor: (row) => row.vehicleNumber ?? "N/A",
          width: 30,
        },
        { header: "Vehicle Type", accessor: (row) => row.vehicleType ?? "N/A", width: 30 },

        {
          header: "Driver Name",
          accessor: (row) => row.driverName ?? "N/A",
          width: 30,
        },
        {
          header: "Driver Number",
          accessor: (row) => row.driverNumber ?? "N/A",
          width: 28,
        },
        {
          header: "Pickup Date Time",
          accessor: (row) => formatDateForDisplay(row.beforeDateTime) ?? "N/A",
          width: 35,
        },
        ...(isClearingAndDisinfectionReport
          ? [
            {
              header: "Transfer Station Name",
              accessor: (row) => row.transferStationName ?? "N/A",
              width: 30,
            },
            {
              header: "Transfer Station Type Name",
              accessor: (row) => row.transferStationTypeName ?? "N/A",
              width: 30,
            },
            {
              header: "Functional/Non-Functional",
              accessor: (row) => row.remarks ?? "N/A",
              width: 30,
            },
          ]
          : []),
        {
          header: "Latitude",
          accessor: (row) => row.beforeLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Longitude",
          accessor: (row) => row.beforeLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "Before Image",
          accessor: r => r.beforeImageUrl,
          isImage: true,
          width: 20,
        },
        {
          header: "After Image",
          accessor: r => r.afterImageUrl,
          isImage: true,
          width: 20,
        },
      ],
      landscape: true,
    });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                {t(reportTitle)} (
                {formatDateForDisplay(startDate)} to{" "}
                {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row" style={{ textAlign: "left" }}>
                          <div className="col-md-2">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              value={startDate}
                              className="form-control"
                              max={endDate ? endDate : getCurrentDateTime()}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              min={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-2">
                            <label>Vehicle Number</label>
                            <input
                              type="text"
                              name="vehicleTypeCode"
                              style={inputStyle}
                              placeholder="Vehicle Number"
                              className="form-control"
                              value={vehicleNumber}
                              onChange={(e) => {
                                setVehicleNumber(
                                  e.target.value.replace(/\s+/g, ""),
                                );
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="VehicleTypeId">Vehicle Type</label>
                            <Select
                              isMulti
                              className="basic-multi-select"
                              classNamePrefix="select"
                              name="vehicleTypes"
                              options={vehicleTypeDetails
                                .filter((v) => v.isActive)
                                .map((v) => ({ value: v.vehicleTypeId, label: v.vehicleTypeName }))}
                              value={selectedVehicleTypes}
                              onChange={(selected) => setSelectedVehicleTypes(selected || [])}
                              placeholder="Select Vehicle Types"
                              isClearable
                            />
                          </div>
                          <div className="col-md-2">
                            <label htmlFor="ZoneId">Zone:</label>
                            <select
                              name="ZoneId"
                              className="form-select"
                              value={zoneId}
                              onChange={(e) => setZoneId(e.target.value)}
                            >
                              <option value="">Select</option>
                              {allZones &&
                                allZones
                                  ?.filter((zone) => zone.isActive)
                                  .map((zone) => (
                                    <option
                                      key={zone.zoneId}
                                      value={zone.zoneId}
                                    >
                                      {zone.zoneName}
                                    </option>
                                  ))}
                            </select>
                          </div>
                          {isClearingAndDisinfectionReport && (
                            <div className="col-md-2">
                              <label htmlFor="TransferStationTypeId">Activity Type</label>
                              <select
                                name="TransferStationTypeId"
                                className="form-select"
                                value={transferStationTypeId}
                                onChange={(e) => setTransferStationTypeId(e.target.value)}
                              >
                                <option value="">Select</option>
                                {transferStationTypes?.map((type) => (
                                  <option
                                    key={type.transferStationTypeId}
                                    value={type.transferStationTypeId}
                                  >
                                    {type.transferStationName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          <div className="col-md-5">
                            <div className="d-flex gap-3 justify-content-between">
                              <button
                                type="submit"
                                className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                              >
                                Search
                              </button>

                              <button
                                className="btn btn-excel ms-auto mt-4"
                                onClick={downloadAsExcel}
                              >
                                {isExcelLoading ? <SmallLoader /> : <span>
                                  <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                                  Excel
                                </span>}
                              </button>

                              <button
                                className="btn btn-excel ms-auto mt-4"
                                onClick={() => dowanloadExcel(true)}
                              >
                                {isExcelWithImagesLoading ? <SmallLoader /> : <span>
                                  <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                                  Excel + Images
                                </span>}
                              </button>

                              <button
                                className="btn btn-excel ms-auto mt-4"
                                onClick={downloadPdf}
                              >
                                <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                                Pdf
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="mt-3">
                    <div className="">
                      <TableComponent
                        DataFetchURL={transformedData}
                        headers={headers}
                        imgField="image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(AnimalCarReport);
